export const environment = {
    production: true,
    version: '20260818.1', // Version number placeholder, will be replaced with actual version in pipelines
    environmentName: 'PROD',
    clientSecret: '6f478475-8234-440d-b37b-0c98144b88d0',
    applicationInsightsInstrumentationKey: 'a31cb758-ac82-408b-ab62-bea4afd9e77d',
    backendBaseUri: 'https://backend.headpower.fi/',
    accountBaseUri: 'https://account.headpower.fi/',
    portalBaseUri: 'https://portal.headpower.fi/',
    backendPortalUri: 'https://backend.headpower.fi/Portal.BackEnd/',
    productApiKey: 'E3920412-5086-4CB6-B36E-2145D4397D30',
    instructionApiBaseUri: 'https://cms-ohjeistot.headpower.fi/',
    applicationInsightsConnectionString: "InstrumentationKey=864a0f54-0e4f-460d-ae05-a7447a0be6a7;IngestionEndpoint=https://westeurope-0.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/;ApplicationId=7867fc1e-b288-4a4e-b4aa-c1a9316bf42d"
};
